module.exports = __webpack_public_path__ + "img/keymap-modal-new.c0ac130f.svg";